import { createFeatureSelector, createSelector } from '@ngrx/store';

import { LiveAnomalyState } from '@core/store/live-anomalies/anomalies.reducers';
import { REDUCER_LIVE_ANOMALY_ID } from '@anomalies/constants/anomaly-state.constants';

export const liveAnomalies = createFeatureSelector<LiveAnomalyState>(REDUCER_LIVE_ANOMALY_ID);

export const selectAnomalyConnectionState = createSelector(liveAnomalies, (data) => data);
export const selectEventStreamsLoading = createSelector(liveAnomalies, (data) => data.loading);
